// this is going to be global contract in the lib
import { Event } from "../../contracts";
import { getURLName } from "../getURLName";
import { getURLDate } from "../getURLDate";
import { EventsBySportIdRequest } from "sb-resp-lib";

export const mapLinkUrl = (ajustLive:Function, ajustPreLive: Function,x: Event): Event => {
    x.linkUrl = "";
    if (x.isLive) {
        x.linkUrl = ajustLive(x.id);
    } else {
        const sportName = getURLName(x.sportName);
        const leagueName = getURLName(x.leagueName);
        const eventDate = x.type !== EventsBySportIdRequest.EventTypesEnum.Outright.toString() ? getURLDate(x.startEventDate) : "";
        const eventName = getURLName(x.eventName);
        const urlParams = `${sportName}/${leagueName}${eventDate}/${eventName}`;
        x.linkUrl = ajustPreLive(urlParams);
    }

    return x;
}